import { ResolverType } from './resolver-types.enum';
import { resolvers } from './resolvers-config';
import { RouteMatchResult, IRouteResolver } from './types';

export class UrlMatcher {
    private readonly resolvers: Array<() => IRouteResolver> = resolvers;

    public match(url: string): RouteMatchResult {
        const path: string = url.replace(/^https?:\/\/[^/]+/, '');

        for (const resolver of this.resolvers) {
            const resolverInstance: IRouteResolver = resolver();
            const match: RegExpMatchArray | null = path.match(resolverInstance.pattern);

            if (match) {
                return {
                    type: resolverInstance.type,
                    params: resolverInstance.resolve(match)
                };
            }
        }

        return {
            type: ResolverType.WEBVIEW,
            params: { url: path }
        };
    }
}
